// customPaymentQueryKey.ts

/**
 * Stable React Query key for a single Custom Payment record.
 */
export const customPaymentQueryKey = (paymentGuid: string) => ['customPayment', paymentGuid];
